import React from 'react';
import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SidebarBtnWrap, SidebarRoute} from './SidebarElements';

const Sidebar = ({isOpen, toggle}) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>
            <SidebarMenu>
                <SidebarLink to="aboutus" onClick={toggle}>
                    About Us
                </SidebarLink>
                <SidebarLink to="ourclients" onClick={toggle}>
                Our Clients
                </SidebarLink>
                <SidebarLink to="jobs" onClick={toggle}>
                    Jobs
                </SidebarLink>
            </SidebarMenu>
            <SidebarBtnWrap>
                    <SidebarRoute to='/contactus'> Contact us</SidebarRoute>
                </SidebarBtnWrap>
        </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
